<template>
    <div class="fullreducesend_content">
        <div class="tabs_content">
            <ul>
                <li @click="promotionjump">商品促销</li>
                <li class="active">满减满送</li>
            </ul>
        </div>
        <div class="fullreducesend_box">
            <Collapse simple v-if="listshow" v-model="collapseshow">
                <Panel hide-arrow v-for="(item, index) in goodslist" :key="index">
                    <div class="fullreducesend_collapse_content">
                        <div class="fullreducesend_collapse_left">
                            <label>{{item.typename}}</label>
                            <span>{{item.name}}{{item.zhegoodslimit == 1 ? '，促销商品不享受此活动' : ''}}</span>
                        </div>
                        <div class="fullreducesend_collapse_right">
                            <small :style="{color: (item.status == 1 || item.status == 2) ? '#FF8000' : '#999'}">{{item.statusname}}</small>
                            <span>{{item.startdate}}至{{item.enddate}}</span>
                        </div>
                    </div>
                    <div slot="content" v-if="item.giftinfo.length > 0">
                        <div class="fullreducesend_list_content" :class="{fullreducesend_collapse: item.type != 3}" :style="{'height': item.show ? 'auto' : '92px'}">
                            <div class="goods_line_bottom_box">
                                <div class="goods_list_content B">
                                    <Row :gutter="20">
                                        <Col
                                            class="goods_list_col"
                                            span="24"
                                            v-for="(goods, i) in item.giftinfo"
                                            :key="i">
                                            <div class="goods_list_box" @click="goto(goods.goodsid)">
                                                <div class="goods_list_img" :style="{backgroundImage: 'url(' + goods.img + ')'}"></div>
                                                <div class="goods_list_main">
                                                    <div class="goods_list_title">
                                                        <span>
                                                            <b v-for="(lab, j) in goods.label" :key="j">{{lab}}</b>
                                                            {{goods.goodsname}}
                                                        </span>
                                                    </div>
                                                    <div class="goods_list_fun_content">
                                                        <div class="goods_list_price_content">
                                                            <div class="goods_list_price_left">
                                                                <b>订货价：</b>
                                                                <span>￥{{goods.dinghuocost}}</span>
                                                                <b>/个</b>
                                                                <small>市场价{{goods.market_cost}}元/{{goods.goodsdanwei}}</small>
                                                            </div>
                                                        </div>
                                                        <div class="goods_list_manynorms"><span>4种规格</span></div>
                                                        <div class="goods_list_gather_content">
                                                            <div class="goods_list_gather_sign">
                                                                <span class="goods_list_number">编号 {{goods.goodscode}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                        <div class="fullreducesend_open" v-if="item.giftinfo.length > 1">
                            <span @click="showall(item)">显示全部<i class="icon iconfont icon-icon_zhankai_xiangxia"></i></span>
                        </div>
                    </div>
                </Panel>
            </Collapse>
            <noMsg v-if="notips"></noMsg>
            <Loadings v-if="loading"></Loadings>
            <!-- 分页 -->
            <div class="page_content">
                <Page
                    :total="pagetotal"
                    :current="pagecurrent"
                    :page-size="pagesize"
                    :page-size-opts="pagesizeopts"
                    show-total
                    show-sizer
                    show-elevator
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange" />
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
import noMsg from '@/components/component/nomsg.vue'
import Loadings from '@/components/component/loading.vue'
export default {
    components: {noMsg, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            collapseshow: [], // 默认展开
            goodslist: [], // 商品列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.reducegive,
                {
                    page: this.pagecurrent,
                    pagesize: this.pagesize
                }
            )
            .then(response => {
                console.log(response.data.msg)
                for (var i = 0; i < response.data.msg.datalist.length; i++) {
                    response.data.msg.datalist[i].show = false
                }
                for (var i = 0; i < response.data.msg.datalist.length; i++) {
                    if (response.data.msg.datalist[i].type == 3) this.collapseshow.push(i)
                }
                this.goodslist = response.data.msg.datalist
                this.pagetotal = response.data.msg.pagecontent.num
                this.loading = false
                response.data.msg.datalist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        promotionjump () {
            this.$router.push({
                path: '/Promotion'
            })
        },
        goto (id) { // 跳转详情页
            this.$router.push({
                name: '商品详情',
                params: {
                    id: id
                }
            })
        },
        showall (item) {
            item.show = !item.show
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.fullreducesend_box {
    padding: 0 20px;
}

.fullreducesend_collapse_content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    margin-left: -16px;
}

.fullreducesend_collapse_left,
.fullreducesend_collapse_right {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.fullreducesend_collapse_left > label {
    height: 20px;
    line-height: 21px;
    padding: 0 10px;
    margin-right: 6px;
    font-size: 13px;
    color: #fff;
    background-color: #FF8000;
    border-radius: 2px;
}

.fullreducesend_collapse_left > span {
    font-size: 14px;
    color: #333;
}

.fullreducesend_collapse_left > small {
    font-size: 14px;
    color: #FF8000;
}

.fullreducesend_collapse_right > span {
    font-size: 12px;
    color: #333;
}

.fullreducesend_collapse_right > small {
    margin-right: 10px;
    font-size: 12px;
    color: #FF8000;
}

.fullreducesend_list_content {
    padding: 0 16px 16px;
    overflow: hidden;
}

.fullreducesend_list_content .goods_line_bottom_box {
    padding: 0;
}

.fullreducesend_list_content .goods_list_content {
    margin: 0;
}

.fullreducesend_open {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.fullreducesend_open > span {
    font-size: 12px;
    color: #333;
    cursor: pointer;
}

.fullreducesend_open > span > i {
    margin-left: 4px;
    font-size: 12px;
    color: #999;
}

.no_tips {
    padding: 20px 0 0;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.goods_list_col {
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/views/promotion/fullreducesend.vue